import { render, staticRenderFns } from "./FormControlVariationsOption.vue?vue&type=template&id=c5c8021c&scoped=true"
import script from "./FormControlVariationsOption.vue?vue&type=script&setup=true&lang=js"
export * from "./FormControlVariationsOption.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FormControlVariationsOption.vue?vue&type=style&index=0&id=c5c8021c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5c8021c",
  null
  
)

export default component.exports